import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import AssetsView from "./views/assets-view/AssetsView";
import Header from "./components/header/Header";
import CartSidebar from "./components/cart-sidebar/CartSidebar";
import SavedSearchesSidebar from "./components/saved-searches-sidebar/SavedSearchesSidebar";
import NavBar from "./components/nav-bar/NavBar";
import NuxeoConnect from "./components/nuxeo-connect/NuxeoConnect";
import ConfigurationManager from "./configuration/ConfigurationManager";
import "./App.css";
import NuxeoClient from "./clients/NuxeoClient";
// import Loading from "./components/loading/Loading";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: null,
      showCart: false,
      showSavedSearches: false,
      cartItemsCount: 0,
      reportItems: [],
      showReportView: false,
      currentPage: "",
      reportInProgress: false,
    };

    ConfigurationManager.environment = process.env;

    this._handleConnect = this._handleConnect.bind(this);
    this._handleShowCartClick = this._handleShowCartClick.bind(this);
    this._handleAddToCart = this._handleAddToCart.bind(this);
    this._handleCartItemDeleted = this._handleCartItemDeleted.bind(this);
    this._handleCartRunReport = this._handleCartRunReport.bind(this);
    this._handleUpdateCartItemCount = this._handleUpdateCartItemCount.bind(
      this
    );
    this._handleCloseCart = this._handleCloseCart.bind(this);
    this._handleCartItemClear = this._handleCartItemClear.bind(this);
    this._handleSearchTerm = this._handleSearchTerm.bind(this);
  }

  get currentUser() {
    return this.state.currentUser;
  }

  set currentUser(currentUser) {
    this.setState({ currentUser: currentUser });
  }

  get showCart() {
    return this.state.showCart;
  }

  set showCart(showCart) {
    this.setState({ showCart: showCart });
  }

  get showReportView() {
    return this.state.showReportView;
  }

  set showReportView(showReportView) {
    this.setState({ showReportView: showReportView });
  }

  get showSavedSearches() {
    return this.state.showSavedSearches;
  }

  set showSavedSearches(showSavedSearches) {
    this.setState({ showSavedSearches: showSavedSearches });
  }

  get cartItemsCount() {
    return this.state.cartItemsCount;
  }

  set cartItemsCount(cartItemsCount) {
    this.setState({ cartItemsCount: cartItemsCount });
  }

  get currentPage() {
    return this.state.currentPage;
  }

  set currentPage(currentPage) {
    this.setState({ currentPage: currentPage });
  }

  _handleConnect(event) {
    this.currentUser = event.detail.user;
  }

  _handleShowCartClick(event) {
    this.showCart = !this.showCart;
  }

  _handleCloseCart(event) {
    this.currentPage = event.detail.view;
    this.showCart = false;
  }

  _handleAddToCart(event) {
    const currentItems = this._cartSidebar.items;
    const newItems = currentItems.concat(event.detail.items);

    this._cartSidebar.items = newItems;
    this.showCart = true;
  }

  _handleUpdateCartItemCount(event) {
    this.cartItemsCount = event.detail.count;
  }

  _handleCartItemDeleted(event) {
    let itemsCount = event.detail.items.length;

    this.showCart &= itemsCount > 0;
    this.cartItemsCount = itemsCount;
  }

  _handleCartRunReport(event) {
    let { items, startDate, endDate } = event.detail;
    this._handleFileDownload(items, startDate, endDate);
    this.setState({
      showCart: true,
      // loading: true,
    });
  }

  _handleCartItemClear(event) {
    this._cartSidebar.items = []; // Clear the cart item when change page
    this._handleCartItemDeleted(event);
  }

  async _handleFileDownload(items, startDate, endDate) {
    let toastTimer = setInterval(() => {
      window.Materialize.toast("Report creation in progress...", 2000);
    }, 3000);

    this.setState({ reportInProgress: true });
    var userdata = [
      [
        "Asset Uid",
        "Asset Name",
        "Styleguide Name",
        "Users who downloaded",
        "Download Date",
      ],
    ];

    for (let item in items) {
      let uuid = items[item].uid;
      let currentPageIndex = 0;
      let flag = true;
      while (flag) {
        let {
          data,
          total_pages,
        } = await NuxeoClient.instance().getDownloadReport(
          uuid,
          currentPageIndex,
          startDate,
          endDate
        );
        userdata = [...userdata, ...data];
        if (total_pages - 1 === currentPageIndex || currentPageIndex > 9) {
          flag = false;
        } else {
          currentPageIndex++;
        }
      }
    }
    clearInterval(toastTimer);
    window.Materialize.toast("Asset report Downloading ", 5000);
    let csvContent =
      "data:text/csv;charset=utf-8," +
      userdata.map((e) => e.join(",")).join("\n");
    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `audit-report.csv`);
    document.body.appendChild(link); // Required for FF

    link.click(); // This will download the data file named "my_data.csv".
    this.setState(
      { showCart: false, loading: false, reportInProgress: false },
      () => {
        this._cartSidebar.items = [];
      }
    );
  }

  _handleSearchTerm(filters) {
    this.setState({ searchTerm: filters });
  }

  render() {
    const {
      currentUser,
      showCart,
      cartItemsCount,
      showSavedSearches,
      currentPage,
    } = this.state;

    return (
      <div className="app">
        <NuxeoConnect onConnect={this._handleConnect} />
        <Header currentUser={currentUser} />
        <CartSidebar
          ref={(element) => (this._cartSidebar = element)}
          hidden={!showCart}
          view={currentPage}
          onItemDeleted={this._handleCartItemDeleted}
          onRunReport={this._handleCartRunReport}
          onUpdateCartItemCount={this._handleUpdateCartItemCount}
          searchTerm={this.state.searchTerm}
          currentUser={this.state.currentUser}
          reportInProgress={this.state.reportInProgress}
        />
        <SavedSearchesSidebar hidden={!showSavedSearches} />
        {/* {this.state.loading ? <Loading message="Generating Report" /> : null} */}
        <Router ref={(element) => (this._router = element)}>
          <div className={"showAsset"}>
            <NavBar
              onShowCartClick={this._handleShowCartClick}
              cartActive={showCart}
              cartItemsCount={cartItemsCount}
              onCloseCart={this._handleCloseCart}
            />
            <section className="container">
              <div className="content">
                {/* <Route path={SubmissionsView.getPath()} render={() => <SubmissionsView onAddToCart={this._handleAddToCart} onClearToCart={this._handleCartItemClear} />} /> */}
                <Switch>
                  <Route exact path="/AuditReport/">
                    <AssetsView
                      onAddToCart={this._handleAddToCart}
                      onClearToCart={this._handleCartItemClear}
                      currentUser={currentUser}
                      handleSearchTerm={this._handleSearchTerm}
                    />
                  </Route>
                </Switch>
              </div>
            </section>
          </div>
        </Router>
      </div>
    );
  }
}

export default App;
